// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.datepick .react-datepicker-wrapper {
  display: block;
}
.react-datepicker-wrapper input {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-body-color);
  appearance: none;
  background-color: var(--bs-body-bg);
  background-clip: padding-box;
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: 0px;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
label {
  font-size: 14px;
  font-weight: 400;
  color: rgb(34, 34, 34);
}
.qrcode-list {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}
.qrcode-item {
  border: 1px solid #ccc;
  padding: 10px;
  border-radius: 8px;
}
#flowStyle {
  display: none;
}
.herebyDeclareParagraph p{
  font-style: italic;
}
.herebyDeclareParagraph .label.form-check{
  padding-bottom: 10px;
}

.herebyDeclareParagraph .form-check-input[type=checkbox] {
  margin-top: 5px;
}
.aadhaarOTP_paragraph, .aadhaarAuthentication p, .abhaAddressChange p {
  font-size: 14px;
  font-weight: 400;
  padding-top: 15px;
  margin-bottom: 0px;
}
.authenticationType{
  padding-top:10px;
}
.aadhaarAuthentication{
  margin-bottom: 10px;
}
.consentCollectionAadhaar button{
  border-color:#dee2e6;
}
.aadhaarAuthenticationOTP{
  padding-bottom: 10px;
}
.abhaprofilediv{
  padding-bottom: 10px;
}
.abhaprofilediv label{
  font-weight: 500;
}
.widget_BG.existingabha{
  display: inline-block;
}
.abhaverification input, .abhaaddressverificationOTP input{
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/Sidebar/ABHA/Abha.css"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,2BAA2B;EAC3B,gBAAgB;EAChB,mCAAmC;EACnC,4BAA4B;EAC5B,2DAA2D;EAC3D,kBAAkB;EAClB,wEAAwE;AAC1E;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;AACA;EACE,sBAAsB;EACtB,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;AACpB","sourcesContent":[".datepick .react-datepicker-wrapper {\r\n  display: block;\r\n}\r\n.react-datepicker-wrapper input {\r\n  display: block;\r\n  width: 100%;\r\n  padding: 0.375rem 0.75rem;\r\n  font-size: 1rem;\r\n  font-weight: 400;\r\n  line-height: 1.5;\r\n  color: var(--bs-body-color);\r\n  appearance: none;\r\n  background-color: var(--bs-body-bg);\r\n  background-clip: padding-box;\r\n  border: var(--bs-border-width) solid var(--bs-border-color);\r\n  border-radius: 0px;\r\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\r\n}\r\nlabel {\r\n  font-size: 14px;\r\n  font-weight: 400;\r\n  color: rgb(34, 34, 34);\r\n}\r\n.qrcode-list {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 20px;\r\n}\r\n.qrcode-item {\r\n  border: 1px solid #ccc;\r\n  padding: 10px;\r\n  border-radius: 8px;\r\n}\r\n#flowStyle {\r\n  display: none;\r\n}\r\n.herebyDeclareParagraph p{\r\n  font-style: italic;\r\n}\r\n.herebyDeclareParagraph .label.form-check{\r\n  padding-bottom: 10px;\r\n}\r\n\r\n.herebyDeclareParagraph .form-check-input[type=checkbox] {\r\n  margin-top: 5px;\r\n}\r\n.aadhaarOTP_paragraph, .aadhaarAuthentication p, .abhaAddressChange p {\r\n  font-size: 14px;\r\n  font-weight: 400;\r\n  padding-top: 15px;\r\n  margin-bottom: 0px;\r\n}\r\n.authenticationType{\r\n  padding-top:10px;\r\n}\r\n.aadhaarAuthentication{\r\n  margin-bottom: 10px;\r\n}\r\n.consentCollectionAadhaar button{\r\n  border-color:#dee2e6;\r\n}\r\n.aadhaarAuthenticationOTP{\r\n  padding-bottom: 10px;\r\n}\r\n.abhaprofilediv{\r\n  padding-bottom: 10px;\r\n}\r\n.abhaprofilediv label{\r\n  font-weight: 500;\r\n}\r\n.widget_BG.existingabha{\r\n  display: inline-block;\r\n}\r\n.abhaverification input, .abhaaddressverificationOTP input{\r\n  text-align: center;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
